<template lang="pug">
.cumpleanos
  .titulo
    span 🎂 Cumpleaños de hoy
  .contenedor-scroll(v-if="lista.length")
    .empleado(
      v-for="o in lista"
      :key="o.codigo"
    )
      .avatar
        img(
          :src="o.pathFoto"
          @error="imagenDefault"
        )
      .datos
        .nombre
          //- .margin-right-5(v-if="o.esCumpleanios")
          //-   i.fa.fa-birthday-cake.fs-17
          strong {{o.nombre}}
        .cargo
          span {{ o.fechaNacimiento | customDate}}
        .area
          span {{o.nombreArea}}
      //- button.btn-saludo(
      //-   @click="saludar(empleado)"
      //- )
      //-   i.fa.fa-birthday-cake
      //-   |  Saludar
  .sin-datos(v-else)
    span No hay cumpleaños hoy 🎈
</template>
<script>
import { apiGet, notify }  from '../../util/general'
import moment from 'moment';
export default {
  name:'KpiCumpleanos',
  data () {
    return {
      lista                                 : [],
      mes                                   : moment().month() + 1,
      isLoading                             : false,
      disabledScrollExecute                 : false,
      noMore                                : false,
      isScroll                              : false,
      skip                                  : 0
    }
  },
  created () {
    this.fetch()
  },
  methods: {
    fetch () {
      var vm                    = this
      vm.isLoading              = true
      vm.disabledScrollExecute  = true
      vm.noMore                 = false
      if (!vm.isScroll) {
        vm.lista = []
        vm.skip = 0
      }

      var obj = {
        mes: vm.mes,
        skip : vm.skip
      }

      apiGet(vm, '/empleado/cumpleanios', obj, function (data) {
        console.log('data.lista >>>>>>', data.lista)
        for (var i = 0; i < data.lista.length; i++) {
          if (data.lista[i].esCumpleanios) {
            vm.lista.push(data.lista[i])
          }
        }
        if (data.noMore) {
          vm.noMore = true
          vm.disabledScrollExecute = true
        } else {
          vm.skip += data.lista.length
          vm.disabledScrollExecute = false
        }
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isScroll  = false
        vm.isLoading = false
      })
    },
    imagenDefault (event) {
      event.target.src = '/img/avatar-default.png'
    },
    saludar (empleado) {
      this.$emit(
        'saludar',
        empleado
      )
    }
  }
}
</script>
<style lang="stylus" scoped>
.birthday-style
  background-color: #565CDE !important
  color: white
  &:hover
    background-color: #565CDE !important
.contenedor-scroll
  flex 1
  overflow-y auto
  padding-right 6px
  &::-webkit-scrollbar
    width 6px
  &::-webkit-scrollbar-thumb
    background #bdbdbd
    border-radius 10px
  &::-webkit-scrollbar-track
    background transparent
.cumpleanos
  background white
  border-radius 10px
  padding 20px
  box-shadow 0 2px 8px rgba(0,0,0,.08)
  width 360px
  height 420px
  display flex
  flex-direction column
.titulo
  font-size 16px
  font-weight bold
  margin-bottom 15px
.empleado
  display flex
  align-items center
  padding 12px 0
  border-bottom 1px solid #eee
.avatar
  width 55px
  height 55px
  border-radius 50%
  overflow hidden
  margin-right 15px
  img
    width 100%
    height 100%
    object-fit cover
.datos
  flex 1
.nombre
  font-size 14px
.cargo,
.area
  font-size 12px
  color #777
.btn-saludo
  border none
  background #ff6b81
  color white
  padding 6px 10px
  border-radius 15px
  cursor pointer
  font-size 11px
.sin-datos
  text-align center
  color #888
</style>



// WEBPACK FOOTER //
// c_kpi_cumpleanos.vue?35729d3b